export const messages = {
  en: {
    editMaintainancePlan: {
      title: 'Edit Maintenance Plan',
      planName: 'Plan Name',
      planNamePlaceholder: 'Required, please enter plan name',
      standard: 'Maintenance Standard',
      standardPlaceholder: 'Required, please select maintenance standard',
      period: 'Inspection Cycle',
      periodPlaceholder: 'Required, please select inspection cycle',
      month: 'Month',
      monthUnit: 'Month',
      day: 'Day',
      dayUnit: 'Day',
      fixedDay: 'Fixed Days',
      fixedDayPlaceholder: 'Required, please enter days',
      startDate: 'Start Date',
      startDatePlaceholder: 'Required, please select start date',
      endDate: 'End Date',
      endDatePlaceholder: 'Required, please select end date',
      selectStaff: 'Select Staff',
      saveSuccess: 'Save successfully',
      saveError: 'Save failed',
      fetchStandardError: 'Failed to get maintenance standards',
      fetchPlanError: 'Failed to get maintenance plan',
      fetchStaffError: 'Failed to get staff list'
    },
    orgTree: {
      fetchError: 'Failed to get organization tree'
    }
  },
  zh: {
    editMaintainancePlan: {
      title: '修改保养计划',
      planName: '计划名称',
      planNamePlaceholder: '必填，请填写计划名称',
      standard: '保养标准',
      standardPlaceholder: '必填，请选择保养标准',
      period: '巡检周期',
      periodPlaceholder: '必填，请选择巡检周期',
      month: '月',
      monthUnit: '月',
      day: '日',
      dayUnit: '日',
      fixedDay: '固定天数',
      fixedDayPlaceholder: '必填，请填写多少天后保养一次',
      startDate: '开始日期',
      startDatePlaceholder: '必填，请填写开始日期',
      endDate: '结束日期',
      endDatePlaceholder: '必填，请填写结束日期',
      selectStaff: '选择员工',
      saveSuccess: '保存成功',
      saveError: '保存失败',
      fetchStandardError: '获取保养标准失败',
      fetchPlanError: '获取保养计划失败',
      fetchStaffError: '获取员工列表失败'
    },
    orgTree: {
      fetchError: '获取组织树失败'
    }
  }
}